/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { FragmentSocialUploadProjectDto } from "./FragmentSocialUploadProjectDto";
import type { FragmentSourceDto } from "./FragmentSourceDto";
import type { MediaUrlSourceDto } from "./MediaUrlSourceDto";
import type { RelatedUserDto } from "./RelatedUserDto";
import type { UploadCancelledDataDto } from "./UploadCancelledDataDto";
import type { UploadCompletedDataDto } from "./UploadCompletedDataDto";
import type { UploadFailedDataDto } from "./UploadFailedDataDto";
import type { UploadInProgressDataDto } from "./UploadInProgressDataDto";
import type { UploadPlatformFeaturesDto } from "./UploadPlatformFeaturesDto";
import type { UploadScheduledDataDto } from "./UploadScheduledDataDto";
import type { UploadWaitingChildrenDataDto } from "./UploadWaitingChildrenDataDto";
import type { UploadWaitingDataDto } from "./UploadWaitingDataDto";
import type { VideoEditorProjectSourceDto } from "./VideoEditorProjectSourceDto";

export const FragmentSocialUploadItemDtoPlatformEnum = {
    YOUTUBE: "YOUTUBE",
    TWITTER: "TWITTER",
    INSTAGRAM: "INSTAGRAM",
    DAILYMOTION: "DAILYMOTION",
    FACEBOOK: "FACEBOOK",
    DEMO: "DEMO",
    TIKTOK: "TIKTOK"
} as const;

export type FragmentSocialUploadItemDtoPlatformEnumKey = (typeof FragmentSocialUploadItemDtoPlatformEnum)[keyof typeof FragmentSocialUploadItemDtoPlatformEnum];

export const FragmentSocialUploadItemDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type FragmentSocialUploadItemDtoStatusEnumKey = (typeof FragmentSocialUploadItemDtoStatusEnum)[keyof typeof FragmentSocialUploadItemDtoStatusEnum];

export type FragmentSocialUploadItemDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    platform: FragmentSocialUploadItemDtoPlatformEnumKey;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type string
    */
    stationId: string;
    /**
     * @type string
    */
    key: string;
    source: (MediaUrlSourceDto | FragmentSourceDto | VideoEditorProjectSourceDto);
    data: (UploadScheduledDataDto | UploadWaitingDataDto | UploadWaitingChildrenDataDto | UploadInProgressDataDto | UploadCompletedDataDto | UploadFailedDataDto | UploadCancelledDataDto);
    /**
     * @type object
    */
    publishData: {
        [key: string]: any;
    };
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    status: FragmentSocialUploadItemDtoStatusEnumKey;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @description Platform-specific features (manage URL, public URL, deletability)
    */
    platformFeatures?: UploadPlatformFeaturesDto;
    /**
     * @type object
    */
    creator: RelatedUserDto;
    /**
     * @type object | undefined
    */
    project?: FragmentSocialUploadProjectDto;
};